import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export function LogoutModal(): JSX.Element | null {
  const { isLogoutModalOpen, closeLogoutModal, logout } = useAuthStore()
  const navigate = useNavigate()

  if (!isLogoutModalOpen) return null

  async function handleLogout(): Promise<void> {
    await logout()
    navigate('/login')
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl sm:p-8">
        <h2 className="mb-2 text-center text-2xl font-bold text-gray-900">Logging Out?</h2>
        <p className="mb-6 text-center text-sm text-gray-500">
          Do you really want to logout your account?
        </p>
        <div className="flex gap-3">
          <button
            onClick={closeLogoutModal}
            className="flex-1 rounded-full border border-gray-300 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleLogout}
            className="flex-1 rounded-full bg-brand-green py-3 text-sm font-semibold text-white hover:opacity-90"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  )
}
